import { useState, useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import isObject from 'lodash/isObject'
import Slider from 'react-slick'
import API from '../../api'
import { FormattedMessage } from 'react-intl'
import PriceConverter, { convertCurrency } from '../helpers/PriceConverter'
import { pushToDataLayer } from 'gtm'
import get from 'lodash/get'
import { roundPrice, getKindVerbose } from 'utils'
import PropTypes from 'prop-types'

function OtherDiveOperators({ date, eCommerceListName, padiCheckoutName }) {
  const ref = useRef()
  const [operators, setOperators] = useState([])
  const settings = {
    slidesToShow: 4,
    slidesToScroll: 4,
    infinite: false,
    dots: true,
    lazyLoad: 'ondemand',
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
    beforeChange: (a, b) => {
      const difference = b + Math.abs(a - b)
      pushToDataLayer({ ecommerce: null })
      pushToDataLayer({
        event: 'view_item_list',
        padi_checkout_name: padiCheckoutName,
        ecommerce: {
          currency: 'USD',
          items: operators.slice(b, difference).map((item) => item.viewItem),
        },
      })
    },
  }

  useEffect(() => {
    const numberOfItemsToShow = get(
      ref,
      'current.innerSlider.props.slidesToShow',
    )
    if(numberOfItemsToShow && operators.length) {
      pushToDataLayer({ ecommerce: null })
      pushToDataLayer({
        event: 'view_item_list',
        padi_checkout_name: padiCheckoutName,
        ecommerce: {
          currency: 'USD',
          items: operators
            .slice(0, numberOfItemsToShow)
            .map((item) => item.viewItem),
        },
      })
    }
  }, [ref.current, operators.length])

  useEffect(() => {
    getOperators()
  }, [date])

  function getOperators() {
    API(`shop/${window.shop.slug}/other-operators/`)
      .get({
        date: date || undefined,
      })
      .then((operators) => {
        if(Array.isArray(operators)) {
          operators.forEach((operator, index) => {
            operator.viewItem = {
              item_name: operator.title,
              item_id: operator.id.toString(),
              price: Number(
                roundPrice(
                  convertCurrency(operator.priceMin, operator.currency, 'USD'),
                ),
              ),
              item_brand: 'PADI',
              item_category: 'PADI Travel',
              item_category2: getKindVerbose(operator.kind),
              item_category3: '',
              item_category4: '',
              item_category5: '',
              item_list_name: eCommerceListName,
              index: index + 1,
              quantity: 1,
            }
          })
          setOperators(operators)
        }
      })
  }

  if(!operators.length) {
    return (
      <FormattedMessage
        id='there_is_no_items'
        defaultMessage='There is no items'
      />
    )
  }

  return (
    <Slider className='slick-pt-custom same-height' ref={ref} {...settings}>
      {operators.map((shop) => {
        const handleClick = () => {
          if(shop.viewItem) {
            pushToDataLayer({
              event: 'select_item',
              padi_checkout_name: padiCheckoutName,
              ecommerce: {
                currency: 'USD',
                items: [shop.viewItem],
              },
            })
          }
          window.location.href = shop.url
        }
        return (
          <div className='element' onClick={handleClick} key={shop.id}>
            <div className='img-wrapper'>
              <span
                style={{
                  backgroundImage: `url(${shop.backgrounds.GridSearchResultDesktop})`,
                }}
                className='img'
              />
            </div>

            <div className='info'>
              <strong className='shop-title'>{shop.title}</strong>
              <ul className='features'>
                <li>
                  <i className='font-icons location-icon' />
                  {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx  */}
                  {shop.areaTitle}, {shop.countryTitle}
                </li>
                <li>
                  <i className='font-icons dive-center-icon' />
                  <FormattedMessage
                    id='including_dives_fixed'
                    defaultMessage='Including 14-20 dives'
                  />
                </li>
              </ul>
              <div className='price-wrap'>
                <span className='price'>
                  <PriceConverter
                    amount={shop.priceMin}
                    currency={shop.currency}
                  />
                </span>
                {shop.kind === 10 ? (
                  <span className='price-type'>
                    &nbsp;
                    <FormattedMessage
                      id='per_person_trip'
                      defaultMessage='per person/trip'
                    />
                  </span>
                ) : (
                  <span className='price-type'>
                    &nbsp;
                    <FormattedMessage
                      values={{
                        numberOfDivers: shop.divers,
                        nights: shop.nights,
                      }}
                      id='per_divers_for_nights'
                      defaultMessage='per { numberOfDivers } divers for { nights } nights'
                    />
                  </span>
                )}
              </div>
            </div>
          </div>
        )
      })}
    </Slider>
  )
}

export default connect((state) => ({
  date: isObject(state.departureDate === 'object')
    ? state.departureDate.dateFrom
    : state.departureDate,
}))(OtherDiveOperators)

OtherDiveOperators.propTypes = {
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  eCommerceListName: PropTypes.string,
  padiCheckoutName: PropTypes.string,
}
